import { useContext, useMemo } from 'react';
import {
  SipPhoneContext,
  sipPhoneStatuses,
} from '../components/SipPhoneProvider';

const {
  SIP_STATUS_CONNECTED,
  SIP_STATUS_REGISTERED,
  CALL_STATUS_IDLE,
  CALL_STATUS_STOPPING,
} = sipPhoneStatuses;

const useSipStates = () => {
  const { sip, call } = useContext(SipPhoneContext);

  const isConnected = useMemo(
    () => sip.status === SIP_STATUS_REGISTERED,
    [sip.status]
  );

  const isIdle = useMemo(
    () =>
      call.status === CALL_STATUS_IDLE || call.status === CALL_STATUS_STOPPING,
    [call.status]
  );

  return { isConnected, isIdle };
};

export default useSipStates;
